import React, { useEffect, useState } from "react";
import "./dashboard.css";
import { useLocation, useNavigate } from "react-router-dom";
import { RxDimensions } from "react-icons/rx";
import Header from "../../components/common/header.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import imagePaths from "../../assets/imagePaths.js";
import { logMessage } from "../../utils/helpers.js";
import api from "../../api/api.js";
import { ApiResponse } from "../../models/ApiResponseModel.js";
import { Project } from "../../models/projectModel.js";
import paths from "../../utils/constants.js";
import currency from "../../utils/currencyConstants.js";
import { Scan } from "../../models/ScanModel.js";

const EditProject = ({ startLoading, stopLoading }) => {
  const isVip = localStorage.getItem("isVip"); // Get VIP status
  const isVerifiedLocal = localStorage.getItem("isVerified"); // Get verification status (string)

  let isVerified = false; // Default to false

  if (isVip === "true") {
    isVerified = true; // VIP users are always verified
  } else if (isVip === "false" && isVerifiedLocal === "true") {
    isVerified = true; // Non-VIP users are verified only if isVerified is "true"
  }

  //  console.log("isVip"+isVip)

  const navigate = useNavigate();
  const [tag, setTag] = useState("");
  const [scannedResult, setScannedResult] = useState("");
  const [barcode, setBarcode] = useState("");
  const [description, setDescription] = useState("");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const projectId = queryParams.get("project_id");
  if (projectId == undefined) {
    // alert("invalid project")
    logMessage("invalid project", "alert");
  }
  const [isOpen, setIsOpen] = useState("");
  const [localImage, setLocalImages] = useState([]);
  const [isImageChanged, setIsImageChanged] = useState(false);
  const [formData, setFormData] = useState({
    design: "",
    image: [],
    project_id: "",
    artist: "",
    brand: "",
    canvas_width: 0,
    canvas_height: 0,
    diamond_type: "",
    no_of_color: "",
    abs: 0,
    glow: 0,
    crystal: 0,
    dreamerDust: 0,
    special_status: false,
    free_status: false,
    country_code: "",
    currency_code: "",
    total_amount_diamonds: 0,
    price: 0,
    extraNotes: "",
    startDate: "",
    endDate: "",
    orderStartDate: "",
    orderEndDate: "",
    kitReleaseDate: "",
    submit_project: false,
    tags: [],
  });

  const handleTagChange = (e) => {
    setTag(e.target.value);
  };

  const getLeaderboardDescription = async () => {
    try {
      startLoading();
      const response = await api.getLeaderboardDescription();
      const apiResponse = new ApiResponse(response.status, response.message);
      if (apiResponse.status === 1) {
        // navigate(paths.ADD_PROJECT);
        // console.log(apiResponse);
        setDescription(response.data);
        stopLoading();
      } else {
        logMessage(apiResponse.message, "alert");
      }
    } catch (error) {
      logMessage(error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    getLeaderboardDescription();
  }, []);

  const fetchProjectDetail = async () => {
    try {
      startLoading();
      const data = {
        project_id: projectId,
      };
      const token = localStorage.getItem("token");
      console.log(token);
      const response = await api.getProjectDetail(data);
      const apiResponse = new ApiResponse(response.status, response.message);
      if (apiResponse.status === 1) {
        logMessage(response.data);
        const projectData = new Project(response.data);
        logMessage("countrycode" + projectData.country_code);
        setLocalImages(projectData.image);

        setFormData({
          design: projectData.design,
          project_id: projectId,
          image: projectData.image,
          artist: projectData.artist,
          brand: projectData.brand,
          canvas_width: projectData.canvas_width,
          canvas_height: projectData.canvas_height,
          diamond_type: projectData.diamond_type,
          no_of_color: projectData.no_of_color,
          abs: projectData.abs || 0,
          glow: projectData.glow || 0,
          crystal: projectData.crystal || 0,
          dreamerDust: projectData.dreamerDust || 0,
          special_status: projectData.special_status,
          free_status: projectData.projectType == "free" ? true : false,
          country_code: projectData.country_code,
          currency_code: projectData.currency_code,
          total_amount_diamonds: projectData.total_amount_diamonds || 0,
          price: parseFloat(projectData.price || 0),
          extraNotes: projectData.extraNotes,
          startDate: projectData.startDate,
          endDate: projectData.endDate,
          orderStartDate: projectData.orderStartDate,
          orderEndDate: projectData.orderEndDate,
          kitReleaseDate: projectData.kitReleaseDate,
          submit_project: projectData.submit_project || false,
          tags: projectData.tags,
        });
        stopLoading();
      } else {
        logMessage(apiResponse.message, "alert");
      }
    } catch (error) {
      logMessage(error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && token.length <= 0) {
      navigate(paths.AUTH_SCREEN);
    } else {
      logMessage("editprojectcalled");
      fetchProjectDetail();
    }
  }, []);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const currentImages = formData.image || [];
      const totalImages = currentImages.length + 1;

      const uploadedFiles = currentImages.filter((img) => img instanceof File);

      const currentTotalSize = uploadedFiles.reduce(
        (sum, img) => sum + img.size,
        0
      );
      const newTotalSize = currentTotalSize + file.size;
      const newTotalSizeMB = newTotalSize / (1024 * 1024);

      if (totalImages > 4) {
        logMessage("You can't upload more than 4 images.", "alert");
        return;
      }

      if (newTotalSizeMB > 5) {
        logMessage("Total image size can't exceed 5MB.", "alert");
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        setFormData((prevFormData) => ({
          ...prevFormData,
          // image: [...prevFormData.image, e.target.result]
          image: [...prevFormData.image, file],
          // image: [file],
        }));
        setLocalImages((prevImages) => [...prevImages, e.target.result]);
        setIsImageChanged(true);
      };
      reader.readAsDataURL(file);
    }
    event.target.value = null;
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const file = event.dataTransfer.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFormData((prevFormData) => ({
          ...prevFormData,
          image: [...prevFormData.image, file],
          // image: [...prevFormData.image, e.target.result]
          // image: [file],
        }));
        setLocalImages((prevImages) => [...prevImages, e.target.result]);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDeleteImage = (indexToRemove) => {
    setFormData((prev) => ({
      ...prev,
      image: prev.image.filter((_, i) => i !== indexToRemove),
    }));

    setLocalImages((prev) => prev.filter((_, i) => i !== indexToRemove));
    setIsImageChanged(true);
  };

  const handleAddProject = async (event) => {
    event.preventDefault();

    const { total_amount_diamonds, no_of_color } = formData;

    const totalAmountDiamondsInt = Math.floor(total_amount_diamonds);
    const noOfColorInt = Math.floor(no_of_color);

    if (formData.image.length > 4) {
      stopLoading();
      logMessage("You can't upload more than 4 images.", "alert");
      return;
    }

    const totalSizeMB =
      formData.image.reduce((sum, img) => {
        if (img instanceof File) {
          return sum + img.size;
        }
        return sum;
      }, 0) /
      (1024 * 1024);

    if (totalSizeMB > 5) {
      stopLoading();
      logMessage("Total image size can't exceed 5MB.", "alert");
      return;
    }
    const { startDate, endDate, orderStartDate, orderEndDate } = formData;

    if (startDate && endDate && startDate > endDate) {
      logMessage("Start date cannot be greater than end date.", "alert");
      return;
    }
    if (orderStartDate && orderEndDate && orderStartDate > orderEndDate) {
      logMessage(
        "Order start date cannot be greater than order end date.",
        "alert"
      );
      return;
    }

    if (noOfColorInt?.toString()?.length > 9) {
      logMessage("The number of colors must not exceed 9 digits.", "alert");
      return;
    }

    if (totalAmountDiamondsInt?.toString()?.length > 9) {
      logMessage(
        "The total amount of diamonds must not exceed 9 digits.",
        "alert"
      );
      return;
    }

    const updatedFormData = {
      ...formData,
      total_amount_diamonds: totalAmountDiamondsInt,
      no_of_color: noOfColorInt,
      projectType: formData.free_status ? "free" : "paid",
    };
    startLoading();
    try {
      const response = await api.editProject(updatedFormData);
      const apiResponse = new ApiResponse(response.status, response.message);
      if (apiResponse.status == 1) {
        // const signUpResponse = new UserData(response.data);
        // stopLoading();
        // localStorage.setItem('user_data', JSON.stringify(signUpResponse.data));
        // localStorage.setItem('user_email', signUpResponse.email);
        // localStorage.setItem('user_name', signUpResponse.name);
        // localStorage.setItem('profile_picture', signUpResponse.profile_picture);
        // navigate(paths.PROJECT_SCREEN);
        window.location.reload();
      } else {
        logMessage(apiResponse.message, "alert");
      }
    } catch (error) {
      logMessage(error);
    } finally {
      stopLoading();
    }
  };

  const addTag = (e) => {
    e.preventDefault();
    setFormData((prevFormData) => ({
      ...prevFormData,
      tags: [...prevFormData.tags, tag.trim()],
    }));
    setTag("");
  };
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name == "currency_code") {
      let countryCode = "";
      const selectedOption = e.target.selectedOptions
        ? e.target.selectedOptions[0]
        : null;
      countryCode = selectedOption ? selectedOption.getAttribute("cid") : "";
      setFormData({
        ...formData,
        country_code: countryCode.toString(),
        [name]: type === "checkbox" ? checked : value,
      });
    } else {
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value,
      });
    }
    logMessage(formData);
  };

  const handleRemoveTag = (index) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      tags: prevFormData.tags.filter((_, i) => i !== index),
    }));
  };

  const formatDate = (date) => {
    if (!date) return ""; // Handle empty value
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure MM format
    const day = String(date.getDate()).padStart(2, "0"); // Ensure DD format
    const year = date.getFullYear();
    return `${month}/${day}/${year}`; // MM/DD/YYYY format
  };

  const handleDateChange = (date, name) => {
    setFormData({
      ...formData,
      [name]: formatDate(date),
    });
  };

  // const handleDateChange = (e, name) => {
  //   logMessage(e.target.value.toString());
  //   setFormData({
  //     ...formData,
  //     [name]: e.target.value.toString(),
  //   });
  // };

  const uploadImageClick = (e) => {
    e.preventDefault();
    const currentImages = formData.image || [];

    if (currentImages.length >= 4) {
      logMessage("You can't upload more than 4 images.", "alert");
      return;
    }

    document.getElementById("imageUploadInput").click();
  };

  return (
    <div className="full_page_inner">
      <Header />
      <div className="detail_outer_container" style={{ overflow: "auto" }}>
        <div className="detail_inner_container addeditscreen">
          <div className="detail_left_container">
            <div className="top_container">
              <h3>Edit Project</h3>
              {/* <input
                type="text"
                className="barcodeinput"
                placeholder="Enter barcode"
                name="barcode"
                value={barcode}
                onChange={handleBarcodeInputChange}
              ></input> */}
              {/* <button>Submit</button> */}
              {/* <img
                onClick={handleScanClick}
                alt="project_image"
                src={imagePaths.scanner}
              ></img> */}
              {/* <img
                onClick={handleOpenCamera}
                alt="project_image"
                src={imagePaths.scanner}
              ></img> */}
              {/* <img alt="project_image" src={imagePaths.scanner}></img> */}
              {isOpen && (
                <div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      padding: "10px",
                    }}
                  >
                    {/* <button
                      style={{ position: "absolute", top: "5px", right: "5px" }}
                      onClick={handleClose}
                    >
                      Close
                    </button> */}
                    {/* <h2>QR Scanner Component</h2> */}
                    {/* <QrReader
                                            delay={300}
                                            onError={handleError}
                                            onScan={handleScan}
                                            style={{ width: '100%' }}
                                        /> */}
                    {/* <BarcodeScanner onError={handleError} onScan={handleScan} /> */}
                    {/* <h5 style={{textAlign:'center'}}>Enter Barcode</h5> */}
                    {/* <p>Please enter barcode manually in the field</p> */}
                    {/* <input type="text" className="barcodeinput" placeholder="Enter barcode" name="barcode"></input> */}
                    {/* <button>Submit</button> */}
                  </div>
                </div>
              )}
            </div>
            <div
              className="middle_container"
              onDrop={handleDrop}
              onDragOver={(e) => e.preventDefault()}
            >
              {localImage.length > 0 ? (
                <ImageSlider images={localImage} onDelete={handleDeleteImage} />
              ) : (
                <img alt="project_image" src={imagePaths.tree} />
              )}
              <h3 className="dragClass">
                Drag or Upload Design Image
                <span className="mandatoryField"> *</span>
              </h3>
              <p>Four images max. Up to 5MB and in png and jpg only</p>
              <button
                type="button"
                className="uploadImageButton"
                onClick={uploadImageClick}
              >
                Upload Image
              </button>
              <input
                type="file"
                id="imageUploadInput"
                accept="image/png, image/jpeg"
                onChange={handleFileChange}
              />
              {isImageChanged && (
                <button
                  className="uploadImageButton extraSaveButton"
                  type="button"
                  onClick={handleAddProject}
                >
                  Save Changes
                </button>
              )}
            </div>
            <div className="third_container">
              <p>Design Description or Extra Notes:</p>
              <textarea
                onChange={handleChange}
                name="extraNotes"
                value={formData.extraNotes}
                className="designDescription"
              >
                {formData.extraNotes}
              </textarea>
            </div>
          </div>
          <div className="detail_right_container">
            <form onSubmit={handleAddProject}>
              <br></br>
              <div className="form_container addProjectHandle">
                <div className="form_fields">
                  <label>
                    Design:<span className="mandatoryField"> *</span>
                  </label>
                  <input
                    type="text"
                    name="design"
                    value={formData.design}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form_fields">
                  <label>
                    Artist:<span className="mandatoryField"> *</span>
                  </label>
                  <input
                    type="text"
                    name="artist"
                    value={formData.artist}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form_fields">
                  <label>
                    Brand:<span className="mandatoryField"> *</span>
                  </label>
                  <input
                    type="text"
                    name="brand"
                    value={formData.brand}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form_fields">
                  <label>
                    Canvas Size (CM):<span className="mandatoryField"> *</span>
                  </label>
                  <div className="full_container_size">
                    <div className="width_container canvasPadding">
                      <input
                        type="number"
                        name="canvas_width"
                        placeholder="Width"
                        value={
                          formData.canvas_width === 0
                            ? ""
                            : formData.canvas_width
                        }
                        onChange={handleChange}
                        required
                      />
                      <RxDimensions />
                    </div>
                    <div className="height_container canvasPadding">
                      <input
                        type="number"
                        name="canvas_height"
                        placeholder="Height"
                        value={
                          formData.canvas_height === 0
                            ? ""
                            : formData.canvas_height
                        }
                        onChange={handleChange}
                        required
                      />
                      <RxDimensions />
                    </div>
                  </div>
                </div>
                <div className="form_fields">
                  <label>
                    Diamond Info:<span className="mandatoryField"> *</span>
                  </label>
                  <select
                    className="select_options"
                    style={{ color: "#000" }}
                    name="diamond_type"
                    value={formData.diamond_type}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Shape</option>
                    <option value="square">Square</option>
                    <option value="round">Round</option>
                  </select>
                  <input
                    type="number"
                    name="no_of_color"
                    placeholder="No. of Colours"
                    value={formData.no_of_color}
                    onChange={handleChange}
                    // step="1"
                    // min="0"
                    onKeyDown={(e) => {
                      if (
                        e.key === "." ||
                        e.key === "e" ||
                        e.key === "+" ||
                        e.key === "-"
                      ) {
                        e.preventDefault();
                      }
                    }}
                    required
                  />
                </div>
                <div className="form_fields checkbox_field">
                  <div className="checkboxContainer">
                    <input
                      type="checkbox"
                      className="add_special"
                      name="special_status"
                      checked={formData.special_status}
                      onChange={handleChange}
                      // required
                    />
                  </div>
                  <label className="specialDiamonds">
                    Add Special Diamonds:
                  </label>
                </div>
                {formData.special_status && (
                  <div>
                    <div className="form_fields">
                      <label></label>
                      <input
                        type="number"
                        name="abs"
                        value={formData.abs === 0 ? "" : formData.abs}
                        placeholder="AB's:"
                        step="1"
                        min="0"
                        onKeyDown={(e) => {
                          if (
                            e.key === "." ||
                            e.key === "e" ||
                            e.key === "+" ||
                            e.key === "-"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onChange={handleChange}
                      />
                      <input
                        type="number"
                        name="glow"
                        value={formData.glow === 0 ? "" : formData.glow}
                        placeholder="Glow:"
                        step="1"
                        min="0"
                        onKeyDown={(e) => {
                          if (
                            e.key === "." ||
                            e.key === "e" ||
                            e.key === "+" ||
                            e.key === "-"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form_fields">
                      <label></label>

                      <input
                        type="number"
                        name="crystal"
                        value={formData.crystal === 0 ? "" : formData.crystal}
                        placeholder="Crystal:"
                        step="1"
                        min="0"
                        onKeyDown={(e) => {
                          if (
                            e.key === "." ||
                            e.key === "e" ||
                            e.key === "+" ||
                            e.key === "-"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onChange={handleChange}
                      />
                      <input
                        type="number"
                        name="dreamerDust"
                        value={
                          formData.dreamerDust === 0 ? "" : formData.dreamerDust
                        }
                        placeholder="Dreamer Dust:"
                        step="1"
                        min="0"
                        onKeyDown={(e) => {
                          if (
                            e.key === "." ||
                            e.key === "e" ||
                            e.key === "+" ||
                            e.key === "-"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                )}
                <div className="form_fields">
                  <label>Total Amount of Diamonds:</label>
                  <input
                    type="number"
                    name="total_amount_diamonds"
                    value={
                      formData.total_amount_diamonds === 0
                        ? ""
                        : formData.total_amount_diamonds
                    }
                    onChange={handleChange}
                    // step="1"
                    // min="0"
                    onKeyDown={(e) => {
                      if (
                        e.key === "." ||
                        e.key === "e" ||
                        e.key === "+" ||
                        e.key === "-"
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />
                </div>
                <div
                  style={{ justifyContent: "end" }}
                  className="form_fields checkbox_field"
                >
                  <div
                    style={{ width: "max-content", display: "flex" }}
                    className="checkboxContainer"
                  >
                    <input
                      style={{
                        margin: 0,
                        width: "12px",
                        border: "solid 1px #000000",
                      }}
                      type="checkbox"
                      className="add_special"
                      name="free_status"
                      checked={formData.free_status}
                      onChange={handleChange}
                      // required
                    />
                  </div>
                  <label
                    style={{ width: "max-content" }}
                    className="freeProject"
                  >
                    Mark as Free/Gift
                  </label>
                </div>
                {!formData.free_status && (
                  <div className="form_fields">
                    <label>Price:</label>
                    <input
                      type="number"
                      name="price"
                      value={formData.price}
                      onChange={handleChange}
                      required
                    />
                    <select
                      className="select_options"
                      name="currency_code"
                      value={formData.currency_code}
                      onChange={handleChange}
                    >
                      <option value="">Select Currency </option>
                      {currency.map((singleCurrency) => (
                        <option
                          key={singleCurrency.flag}
                          cid={singleCurrency.country_code}
                          value={singleCurrency.currency_code}
                        >
                          {singleCurrency.flag}
                          {singleCurrency.currency_code}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                <div className="form_fields">
                  {/* <div className="date-picker-container"> */}
                  <label>Order and Received Dates: </label>

                  {/* Start Date */}
                  <div className="full_container_size">
                    <div className="width_container">
                      <DatePicker
                        selected={formData.orderStartDate}
                        onChange={(date) =>
                          handleDateChange(date, "orderStartDate")
                        }
                        dateFormat="MM/dd/yyyy"
                        placeholderText="MM/DD/YYYY"
                        className="custom-date-input"
                        popperClassName="custom-datepicker-popper"
                        popperPlacement="bottom-start" // Ensures it shows properly
                      />
                    </div>
                    <div className="height_container">
                      <DatePicker
                        selected={formData.orderEndDate}
                        onChange={(date) =>
                          handleDateChange(date, "orderEndDate")
                        }
                        dateFormat="MM/dd/yyyy"
                        placeholderText="MM/DD/YYYY"
                        className="custom-date-input custom-date-input-right"
                        popperClassName="custom-datepicker-popper"
                        popperPlacement="bottom-start"
                      />
                    </div>
                  </div>
                </div>
                <div className="form_fields">
                  <label>Start and End date:</label>
                  <div className="full_container_size">
                    <div className="width_container">
                      <DatePicker
                        selected={formData.startDate}
                        onChange={(date) => handleDateChange(date, "startDate")}
                        dateFormat="MM/dd/yyyy"
                        placeholderText="MM/DD/YYYY"
                        className="custom-date-input"
                        popperClassName="custom-datepicker-popper"
                        popperPlacement="bottom-start" // Ensures it shows properly
                      />
                    </div>
                    <div className="height_container">
                      <DatePicker
                        selected={formData.endDate}
                        onChange={(date) => handleDateChange(date, "endDate")}
                        dateFormat="MM/dd/yyyy"
                        placeholderText="MM/DD/YYYY"
                        className="custom-date-input custom-date-input-right"
                        popperClassName="custom-datepicker-popper"
                        popperPlacement="bottom-start"
                      />
                    </div>
                  </div>
                </div>
                <div className="form_fields">
                  {/* <div className="date-picker-container"> */}
                  <label> Kit Release Date: </label>

                  <div className="full_container_size">
                    <div className="width_container">
                      <DatePicker
                        selected={formData.kitReleaseDate}
                        onChange={(date) =>
                          handleDateChange(date, "kitReleaseDate")
                        }
                        dateFormat="MM/dd/yyyy"
                        placeholderText="MM/DD/YYYY"
                        className="custom-date-input"
                        popperClassName="custom-datepicker-popper"
                        popperPlacement="bottom-start" // Ensures it shows properly
                      />
                    </div>
                    <div
                      style={{ opacity: 0 }}
                      className="height_container"
                    ></div>
                  </div>
                </div>
                <div className="form_fields">
                  <label>Tags:</label>
                  <div className="tags_combined">
                    <input
                      type="text"
                      name="tags"
                      value={tag}
                      onChange={handleTagChange}
                    />
                    <span className="addTagButton" onClick={addTag}>
                      +
                    </span>
                  </div>
                </div>
                <div className="form_fields">
                  {formData.tags.length > 0 && (
                    <div className="tags">
                      {formData.tags.map((tag, index) => (
                        <span key={index} className="tag addprojectTags">
                          {tag}{" "}
                          <span
                            onClick={() => handleRemoveTag(index)}
                            className="crosstag"
                          >
                            x
                          </span>
                        </span>
                      ))}
                    </div>
                  )}
                </div>

                {isVerified && (
                  <div className="form_fields checkbox_field">
                    <div className="checkboxContainer">
                      <input
                        type="checkbox"
                        className="add_special"
                        name="submit_project"
                        onChange={handleChange}
                        checked={formData.submit_project}
                        // required
                      />
                    </div>
                    <label className="submitProject">
                      Submit this project to the Leaderboard to qualify for
                      prizes. {description}
                    </label>
                  </div>
                )}
                {isVerified && (
                  <div className="form_fields checkbox_field">
                    <div className="checkboxContainer">
                      {/* <input
                        type="checkbox"
                        className="add_special"
                        name="submit_project"
                        // required
                      /> */}
                    </div>
                    <label className="submitProject specialNote">
                      Note: You must upload one image of the canvas clearly
                      showing the start date and another showing the complete
                      canvas with the end date. We will manually verify
                      eligibility for prizes.
                    </label>
                  </div>
                )}
                <button className="addProject" type="submit">
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
const ImageSlider = ({ images, onDelete }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  useEffect(() => {
    if (images.length === 0) {
      setCurrentIndex(0);
    } else if (currentIndex >= images.length) {
      setCurrentIndex(images.length - 1);
    } else if (images.length === 1) {
      setCurrentIndex(0);
    }
  }, [images.length]);

  const handleThumbnailClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="slider-container" style={{ color: "black !important" }}>
      {/* <span
        style={{ color: "black !important" }}
        className="nav-button prev-button"
        onClick={handlePrev}
      >
        ❮
      </span> */}
      <div className="main-image-wrapper">
        <img
          src={images[currentIndex]}
          alt={`slide_${currentIndex}`}
          className="slider-image"
        />
        <button
          className="delete-button-image"
          onClick={() => onDelete(currentIndex)}
        >
          <img
            style={{ width: "20px", height: "20px" }}
            src={imagePaths.crossIcon}
          ></img>
        </button>
      </div>
      {/* <span
        style={{ color: "black !important" }}
        className="nav-button next-button"
        onClick={handleNext}
      >
        ❯
      </span> */}
      {images.length > 1 && (
        <div className="thumbnails-container">
          {images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`thumbnail_${index}`}
              className={`thumbnail-image ${
                currentIndex === index ? "active" : ""
              }`}
              onClick={() => handleThumbnailClick(index)}
            />
          ))}
        </div>
      )}
    </div>
  );
};
export default EditProject;
